import React from "react";
import { Tag } from "@pankod/refine-antd";

import { getMethodMetadata } from "../utils/audit-log.helpers";

type AuditMethodTagProps = {
  method?: string | null;
};

export const AuditMethodTag: React.FC<AuditMethodTagProps> = ({ method }) => {
  const metadata = getMethodMetadata(method);

  return (
    <Tag className={metadata.className} color={metadata.color}>
      {metadata.label}
    </Tag>
  );
};